export const feedbackListSelector = (state) => state.feedback.list;
export const feedbackQuestionsListSelector = (state) => state.feedback.questions;